import { render } from "./RxHeader.vue?vue&type=template&id=4c542596&scoped=true"
import script from "./RxHeader.vue?vue&type=script&lang=js"
export * from "./RxHeader.vue?vue&type=script&lang=js"

import "./RxHeader.vue?vue&type=style&index=0&id=4c542596&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c542596"]])

export default __exports__